import { store } from '../stores/mainStore';
import {history} from '../history';

export class CommandQueue {
	commands = [];
	processing = false;
	constructor(commands) {
		this.commands = commands || [];
		this.process();
	}
	push() {
		this.commands.push(...arguments);
		this.process();
	}

	containsNumbers(str) {
		return /\d/.test(str);
	}

	process() {
		if (this.commands.length) {
			this.processing = true;
			var c = this.commands.shift();
			let m = window.manager;
			console.log('COMM', c.join('---'))
			switch (c[0]) {
				case 'focus-true': //resuming
					store.focus = true;
					store.turnsThisSession = 0;
					store.forceRemoveSpinner();
					//store.debug += '\n' + ['FOCUS :: gs =', store.settings.notifications, 'ss =', store.deviceNotificationsEnabled, 'ds =', c[1], 'm =', store.modal].join(' ')
					if(store.activeMatch && !store.tutorialMode && !!!store.showSkillzSettings) {
						store.showSkillzResume = true;
					}

					if(m && m.cup && m.cup.cupSprite) {
						if (m.cup !== undefined && m.cup.cupSprite !== undefined && m.cup.cupScale !== undefined)
							m.cup.cupSprite.setScale(m.cup.cupScale);
					}
					if(c.length > 1) {
						store.deviceNotificationsEnabled = c[1] === 'true' ? true : false;
						store.changeSetting('notifications', store.deviceNotificationsEnabled);
						if(store.modal === 'turnOnNotifications')
							store.modal = '';
					}
					break;
				case 'focus-false': //about to pause
					store.focus = false;
					if (store.activeMatch) {
						// store.modal = 'resume';
					}
					// store.debug = 'focus-false';
					store.skillzTimeTicking = false;
					break;
				case 'start-ftue':
					console.log('********* RECEIEVED start FTUE');
					if(store.waitingToStartFTUE) {
						store.waitingToStartFTUE = false;
						m.startFTUE();
					}
					break;
				case 'send-rolldata':
					console.log('********* RECEIEVED send-rolldata roll: ' + c[1]);
					// store.debug = 'roll data: ' + c[1];
					const resp = JSON.parse(c[1]);
					console.log(" resp: "+ resp);
					console.log(" faceNumbers: " + resp.faceNumbers);
					if('encryption' in resp && resp.encryption === 'true') {
							// store.skillzResponse.encryptedFaceNumbers = store.skillzResponse.faceNumbers;
							// store.skillzResponse.encryptedFaceNames = store.skillzResponse.faceNames;
							// store.skillzResponse.faceNumbers = Enc.XorMe(store.skillzResponse.encryptedFaceNumbers, 1);
							// store.skillzResponse.faceNames = Enc.XorMe(store.skillzResponse.encryptedFaceNames, 1);
							// store.skillzResponse.faceNumbers = store.skillzResponse.faceNumbers.replaceAll('T', ',');
							// store.skillzResponse.faceNames = store.skillzResponse.faceNames.replaceAll('T', ',');

							// Oksana here is where I left off testing simple decoding of data coming from wrapper.
							// in this test I added 777 to every number before sending to web game.
							// const curArr = store.skillzResponse.faceNumbers.split(',').map(v => (v - 777) );
							// store.skillzResponse.faceNumbers = curArr.join();
							const faceNumbers = resp.faceNumbers.split(',').map(v => v - 777).join(',');
							console.log(" faceNumbers: " + faceNumbers);
							resp.faceNumbers = faceNumbers
						}
					store.skillzResponse = resp;
					break;
				case 'begin-skillzmatch':
					console.log('********* RECEIEVED begin-skillzmatch: ' + c[1]);
					// store.debug = 'BEGINSKILLZMATCH: '+c[1];
					store.skillzResponse = JSON.parse(c[1]);
					if(!store.skillzResponse.errorCode) {
						store.isSkillzInited = false;
						store.createMatch(1).then(response => {
							history.push(`/game/${response.Match.Id}/play`);
						})
					} else {
						store.showSkillzError = true;
					}
					break;
				case 'send-handresult':
					console.log('********* RECEIEVED send-handresult: ');
					// store.debug += ' send-handresult: ' + c[1];
					break;
				/* case 'command-processed':
					console.log('********* RECEIEVED command-processed from native');
					store.wrapperCommandProcessing = false;
					if (window.commands.length) {
						var message = window.commands.shift();
						store.wrapperCommandProcessing = true;
						window.location.href = 'uniwebview://' + message;
					}
					break; */
				default:
					console.warn('command not found', c[0], c);
					break;
			}
		}
		if (this.commands.length) {
			this.process();
		} else {
			this.processing = false;
		}
	}
}
